import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { NotificationInfo } from '../../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Deserialize } from 'cerialize';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends UzurvRestService {
  readonly resourceUrl = 'notifications/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * @param userId
   */
  listByUserId(userId: number): Observable<Array<NotificationInfo>> {
    return this.get<Array<NotificationInfo>>(`${this.resourceUrl}${userId}`).pipe(map(response => Deserialize(response, NotificationInfo)));
  }

  /**
   * @param notificationId
   */
  deleteNotification(notificationId: number): Observable<boolean> {
    return this.delete<boolean>(`${this.resourceUrl}${notificationId}`);
  }
}
